import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Produit } from 'app/models/produit';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { ProduitsService } from 'app/services/produits/produits.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';
import { FormControl } from '@angular/forms';
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-ajouter-produit',
  templateUrl: './ajouter-produit.component.html',
  styleUrls: ['./ajouter-produit.component.scss']
})
export class AjouterProduitComponent implements OnInit {

  produit: Produit = new Produit();
  
  // Form Controls - no validators
  numCommercialFormControl: FormControl;
  emailCommercialFormControl: FormControl;
  agencySearchControl: FormControl;
  
  // File handling
  selectedFiles: FileList;
  fileNames: any[] = [];
  
  // Images
  public image: string = '';
  allAttch: any[] = [];
  
  // Data
  public materiaux: any;
  agenciesApp: any;
  idAgency: any;
  NameAgence: any;
  selectedAgencyId: string = '';  // NEW: store selected agency ID
  filteredAgencies: Observable<any[]>;
  
  // Loading state
  isUploading: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    private router: Router,
    private agenciesService: AgenciesService,
    private produitService: ProduitsService,
    private awsService: AwscontrolService,
    private location: Location
  ) {
    this.numCommercialFormControl = new FormControl('');
    this.emailCommercialFormControl = new FormControl('');
    this.agencySearchControl = new FormControl('');
  }

  ngOnInit(): void {
    this.getData();
    this.idAgency = this.agenciesService.getIdAgency();
    if (this.idAgency) {
      this.AgencyNameById();
    }

    this.filteredAgencies = this.agencySearchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterAgencies(value))
    );
  }

  private _filterAgencies(value: string): any[] {
    const filterValue = value ? value.toLowerCase() : '';
    return this.materiaux ? this.materiaux.filter(agency => 
      agency.name.toLowerCase().includes(filterValue)
    ) : [];
  }

  displayAgency(agency: any): string {
    return agency ? agency.name : '';
  }

  onAgencySelected(event: any): void {
    const selectedAgency = event.option.value;
    if (selectedAgency) {
      this.NameAgence = selectedAgency.name;
      this.selectedAgencyId = selectedAgency.id;  // Store the agency ID
    }
  }

  getData(): void {
    this.getAllAgencies();
    this.agenciesService.getList().subscribe((data) => {
      this.materiaux = data;
    });
  }

  getAllAgencies(): void {
    this.agenciesService.getList().subscribe((data) => {
      this.agenciesApp = data;
    });
  }

  AgencyNameById(): void {
    this.agenciesService.getAgencieById(this.idAgency).subscribe((data: any) => {
      this.NameAgence = data.name;
      this.selectedAgencyId = data.id;  // Store the agency ID
      this.agencySearchControl.setValue(data.name);
    });
  }

  // Image upload – main image only
  selectFileimg(e: any): void {
    this.selectedFiles = e.target.files;
    this.uploadimg();
  }

  uploadimg(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) return;
    
    this.isUploading = true;
    
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles[i];
      this.uploadFileimg(file);
    }
  }

  async uploadFileimg(file: any): Promise<void> {
    this.fileNames.push(file.name);
    
    try {
      const folder = 'produits';
      const response = await this.awsService.uploadFile(file, folder).toPromise();
      
      if (response.success && response.urls && response.urls.length > 0) {
        const uploadedUrl = response.urls[0];
        localStorage.setItem('prodImg', JSON.stringify(uploadedUrl));
        this.allAttch.push(uploadedUrl);
        this.image = uploadedUrl;
      } else {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: response.error || "Échec du téléchargement de l'image",
        });
      }
    } catch (error: any) {
      console.error('Upload error:', error);
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Erreur lors du téléchargement de l'image",
      });
    } finally {
      this.isUploading = false;
    }
  }

  // No validation – always returns true
  validateForm(): boolean {
    return true;
  }

  // Optional video URL – no validation
  validateVideoUrl(): boolean {
    return true;
  }

  onSubmit(): void {
    if (this.isUploading) {
      Swal.fire({
        icon: "warning",
        title: "Téléchargement en cours",
        text: "Veuillez attendre la fin du téléchargement de l'image",
      });
      return;
    }

    this.isSubmitting = true;

    // Convert categoryList array to comma-separated string
    const categoryString = (this.produit.categoryList && this.produit.categoryList.length > 0)
      ? this.produit.categoryList.join(',')
      : '';

    // Get image from either the uploaded variable or localStorage
    let imageUrl = this.image;
    if (!imageUrl) {
      try {
        const stored = localStorage.getItem('prodImg');
        if (stored) imageUrl = JSON.parse(stored);
      } catch (e) { /* ignore */ }
    }

    const produits = {
      name: this.produit.name || '',
      description: this.produit.description || '',
      prix: this.produit.prix || '',
      agencyName: this.NameAgence || '',
      categoryList: categoryString,
      imageUrl: imageUrl || '',
      videoUrlProduit: this.produit.videoUrlProduit || '',
      nomCommercial: this.produit.nomCommercial || '',
      numCommercial: this.numCommercialFormControl.value || '',
      emailCommercial: this.emailCommercialFormControl.value || ''
    };

    console.log('📦 Payload sent:', JSON.stringify(produits));

    this.produitService.createProduit(produits).subscribe(
      () => {
        this.isSubmitting = false;
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Produit créé avec succès",
          timer: 2000
        });
        
        setTimeout(() => {
          // Navigate to the list of products for the selected agency
          if (this.selectedAgencyId) {
            this.router.navigate(['/list-produits', this.selectedAgencyId]);
          } else {
            // Fallback: go back to previous page
            this.navigateBack();
          }
        }, 500);
      },
      (error: HttpErrorResponse) => {
        this.isSubmitting = false;
        console.error("Error:", error);
        
        let errorMessage = "Une erreur s'est produite lors de la création du produit.";
        if (error.error && typeof error.error === 'string') {
          errorMessage = error.error;
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
        }
        
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: errorMessage,
        });
      }
    );
  }

  navigateBack(): void {
    this.location.back();
  }
}